var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container mx-5 my-7",style:(`background-image: ${_vm.backgroundImage}`),attrs:{"id":"bg"}},[_c('h1',[_vm._v("Welcome")]),_c('p',[_vm._v("The Home of African Content")]),_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.downloadApp}},[_vm._v("Download Diapps")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }